import { createFormHook } from "@tanstack/react-form";

import { CheckboxField } from "./CheckboxField";
import { CnhField } from "./CnhField";
import { fieldContext, formContext } from "./context";
import { DateField } from "./DateField";
import { DateTimeField } from "./DateTimeField";
import { NumberField } from "./NumberField";
import { OptionalTextField } from "./OptionalTextField";
import { PhoneField } from "./PhoneField";
import { RgField } from "./RgField";
import { SubmitButton } from "./SubmitButton";
import { TaxIdField } from "./TaxIdField";
import { TextAreaField } from "./TextAreaField";

const appForm = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    OptionalTextField,
    DateTimeField,
    DateField,
    TextAreaField,
    CheckboxField,
    TaxIdField,
    PhoneField,
    CnhField,
    RgField,
    NumberField,
  },
  formComponents: {
    SubmitButton,
  },
});

export const { extendForm } = appForm;
